import React, { useContext, useState, useEffect } from "react";

import warning from "assets/images/organisationProfile/pricing/warning.svg";

import "./planExpiry.scss";
import Button from "components/Button/index";
import PlanSummary from "components/PlanSummary/index";
import RazorpayPayment from "containers/OrganisationProfile/RazorPay/index";
// import init, { IzWasm } from "Wasm/izwasm";
// import { URL } from "URL/url";
import { signupContext } from "context/SignupContext";
// import { useToast } from "components/Toaster/index";

const PlanExpiry = () => {
  const [isPayNowOpen, setIsPayNowOpen] = useState(false);
  const [successState, setSuccessState] = useState(false);
  const [expiryDate, setExpiryDate] = useState("");
  // const [planName, setPlanName] = useState("");

  const {
    //  setOrderId,
    //  setAmount,
    //  setCurrency,
    //  setPaymentObj,
    //  setPaymentKey,
    amount
  } = useContext(signupContext);
  // const showToast = useToast();

  useEffect(() => {
    // Get plan details from localStorage
    const storedExpiryDate = sessionStorage.getItem("expirydate");
    // const storedPlanName = localStorage.getItem("plan");
    

    if (storedExpiryDate) {
      // Format the date for display
      const formattedDate = new Date(storedExpiryDate).toLocaleDateString(
        "en-US",
        {
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      );

      setExpiryDate(formattedDate);
    }

    // setPlanName(storedPlanName);
  }, []);

  const initiatePayment = async () => {
    // await init();
    // const wasmInstance = new IzWasm(URL);
    // try {
    //   const payment = await wasmInstance.init_payment(
    //     localStorage.getItem("mail"),
    //     "",
    //     localStorage.getItem("plan"),
    //     10
    //   );
    //   if (payment.razorpay_payment_id()) {
    //     setOrderId(payment.order_id());
    //     setPaymentObj(payment);
    //     setPaymentKey(payment.razorpay_payment_id());
    //     setAmount(payment.amount());
    //     setCurrency(payment.currency());
    //   }
    // } catch (error) {
    //   console.log(error, "initiate payment error");
    //   showToast(error.message, "initiate payment error");
    // }
  };
  const handlePayNow = async () => {
    
    await initiatePayment();
    setIsPayNowOpen(true);
  };

  const handleCancel = () => {
    setIsPayNowOpen(false);
  };
  // console.log(successState, "successState");
  return (
    <div className="container planExpiryContainer">
      <div className="planExpiry">
        <img src={warning} alt="Warning" />
        <p className="planDetail">
          Your plan expired on <span className="planDate">{expiryDate}</span>{" "}
          Please renew to continue accessing our services.
        </p>
      </div>

      <div className="buttonContainer">
        <Button
          height="48px"
          type="violet"
          title="Pay Now"
          onClick={handlePayNow}
        />
      </div>

      <>
        {isPayNowOpen && (
          <>
            <PlanSummary
              isPayNowOpen={isPayNowOpen}
              handleCancel={handleCancel}
              price={amount}
              successState={successState}
              setSuccessState={setSuccessState}
            />
            {/* // ) : ( */}
            <>
              {successState && (
                <RazorpayPayment
                  successState={successState}
                  setSuccessState={setSuccessState}
                  onDismissFunction={() => {
                    setSuccessState(false);
                  }}
                />
              )}
            </>
          </>
        )}
      </>
    </div>
  );
};

export default PlanExpiry;
